import React, { useState, useEffect } from "react";
import { Modal, Spin, Select, Input, message } from "antd";
import "./MultiSelectModal.css";

const MultiSelectModal = ({
    visible,
    onCancel,
    onSave,
    title,
    loading,
    productName,
    options,
    selectedValues,
    setSelectedValues,
    productLabel,
    selectLabel,
    placeholder,
    optionsAreCountries = false,
    countryList = [],
    showProductSelect = false,
    allProducts = [],
    selectedProduct,
    setSelectedProduct,
    onProductChange
}) => {

const isSaveDisabled = () => {
    if (showProductSelect && !selectedProduct) return true;
    if (!selectedValues || selectedValues.length === 0) return true;
    return false;
};

return (
    <Modal
        title={title}
        visible={visible}
        onCancel={onCancel}
        onOk={() => !isSaveDisabled() && onSave(selectedValues)}
        okButtonProps={{ disabled: isSaveDisabled() }}
        okText="Save"
        cancelText="Cancel"
        confirmLoading={loading}
        width={600}
        maskClosable={false}
        className="multi-select-modal"
    >
        <div className="multi-select-modal-content">
            {showProductSelect ? (
            // Product selection for add mode
            <div className="multi-select-modal-product-select">
                <span className="multi-select-modal-label">Select Product:</span>
                <Select
                style={{ width: "100%" }}
                placeholder="Select a product"
                value={selectedProduct?.id}
                onChange={(value) => {
                    const product = allProducts.find(p => p.id === value);
                    setSelectedProduct(product);
                    // Call the product change callback if provided
                    if (onProductChange) {
                    onProductChange(value);
                    }
                }}
                options={allProducts.map(product => ({
                    value: product.id,
                    label: product.name,
                }))}
                className="multi-select-modal-product-select"
                />
            </div>
            ) : (
            // Product display for edit mode
            <div className="multi-select-modal-product-info">
                <span className="multi-select-modal-label">{productLabel}</span>
                <Input 
                value={productName} 
                disabled 
                className="multi-select-modal-input"
                />
            </div>
            )}

            {loading ? (
            <div className="multi-select-modal-loading-container">
                <Spin size="large" />
            </div>
            ) : (
            <div className="multi-select-modal-select-container">
                <span className="multi-select-modal-label">{selectLabel}</span>
                <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder={placeholder}
                value={selectedValues}
                onChange={setSelectedValues}
                showArrow={true}
                options={options.map(item => ({
                    value: optionsAreCountries 
                    ? countryList.find(c => c.name === item)?.iso || item
                    : item,
                    label: item,
                }))}
                className="multi-select-modal-company-select"
                disabled={showProductSelect && !selectedProduct}
                />
            </div>
            )}
        </div>
        </Modal>
    );
};

export default MultiSelectModal;